import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import RoundImage from '../../components/RoundImage';

const RoundImagePage: React.FC = () => (
  <ToolLayout
    title="Round Image - Circle Crop Online Free | AllTools"
    description="Crop images into circles online. Create round profile pictures with optional borders. Free tool."
    canonicalPath="/round-image"
  >
    <RoundImage />
  </ToolLayout>
);

export default RoundImagePage;
